import { useContext } from "react";
import { IThemeColor } from "../theme/colors";
import { ThemeContext } from "../theme/ThemeContext";

const useColors = (): IThemeColor => {
  const context = useContext(ThemeContext);

  return context.colors;
};

export { useColors };
